import axios from 'axios'

import { config } from 'src/config'

import type { PaginatedProductReviews, ProductRating } from 'src/types/Product'

export const fetchProductReviews = async ({
  skus = [],
  page = 1,
  limit = 10,
  includeRating = false,
}: {
  skus: string[]
  page?: number
  limit?: number
  includeRating?: boolean
}): Promise<PaginatedProductReviews> => {
  try {
    const { data: response }: { data: PaginatedProductReviews } = await axios.get(`${config.serviceHost}/api/reviews`, {
      params: {
        skus: skus.join(','),
        page,
        limit,
        includeRating,
      },
    })

    return response
  } catch (e) {
    return {
      data: [],
      meta: {
        total: 0,
        page: 0,
        hasNextPage: false,
        nextPage: null,
      },
    }
  }
}

export const fetchProductRatingsBySku = async (
  skus: Record<string, string[]>,
): Promise<Record<string, ProductRating>> => {
  try {
    const {
      data: { data: response },
    } = await axios.post(`${config.serviceHost}/api/reviews/ratings-by-sku`, {
      skus,
    })

    return response
  } catch (e) {
    return {}
  }
}
